export default "__VITE_ASSET__BqNZ9kw4__"